import { BaseHttpService } from './baseHttpService';

export class AppHttpService extends BaseHttpService {
  BASE_URL = `${process.env.REACT_APP_DASHBOARD_API_HOST}`;
  getApp = async () => {
    const res = await this.get(`${this.BASE_URL}/app`);
    return res;
  };
}
